import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { Discipline } from '../../models/models';
import { AdditionalFields } from '../common.types';
import { getDateModified, getRoleForMutation } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import { DeficiencyList, DeficiencyListDocument } from './deficiencyList.types';

export const deficiencyListPullQueryBuilder = (document: DeficiencyList) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query deficiencyListFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastRequested: DateTime
      $isLeadInspector: Boolean!
    ) {
      deficiencyListFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
        isLeadInspector: $isLeadInspector
      ) {
        pkDeficiencyUUID
        repairFactorId
        componentFailureId
        isCompletedDuringInspection
        componentType
        causeOfFailure
        remedialAction
        remedialActionId
        commentRemedialAction
        assetCategoryComponentId
        commentAssetComponent
        assetInspectionId
        failureCauseCategory
        areaId
        fkAsset
        fkArea
        pcsId
        isActive
        isAdhoc
        locationDescription
        commentObservation
        name
        dateObserved
        site
        discipline
        dateCreated
        dateModified
        isDelete
        fieldInspectorId
        leadInspectorId
        inspectionTaskId
        commentSiteCoordinator
        commentInspectorLead
        commentInspectorField
        attentionFlag
        taskStatusCategory
        fkComponent
        lowerElevation
        isReInspectedComponent
        upperElevation
        componentVersionId
        inspectorOperationalDowntime
        inspectorConditionRating
        inspectorUrgency
        inspectorTrafficScore
        componentVersionInspectionId
        componentVersionUUID
        componentAreaInfo {
          componentFailureId
          areaId
          areaPcsId
          inspectionId
          trafficSafety
          componentVersionId
        }
      }
    }
  `);

  const variables = {
    siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
    disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
    lastRequested: getDateModified(
      doc?.dateModified,
      doc?.dateCreated,
      doc.site,
      doc.discipline,
      JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
    ),
    isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
  };

  return {
    query,
    variables,
  };
};

export const deficiencyListPushQueryBuilder = (doc: DeficiencyListDocument[]) => {
  const document = doc[0];
  const query =
    document.isDelete === 'False' || !!document.componentVersionInspectionId
      ? print(gql`
          mutation mobileAddOrUpdateDeficiency(
            $role: Int!
            $MobileInspectionDeficienciesListFeedInput: MobileInspectionDeficienciesListFeedInput
          ) {
            mobileAddOrUpdateDeficiency(
              role: $role
              deficiency: $MobileInspectionDeficienciesListFeedInput
            ) {
              assetInsepctionComponentFailureId
              deficiencyUUID
              status
              componentVersionId
            }
          }
        `)
      : print(gql`
          mutation mobileDeleteDeficiency(
            $role: Int!
            $MobileInspectionDeficienciesListFeedInput: MobileInspectionDeficienciesListFeedInput
          ) {
            mobileDeleteDeficiency(
              role: $role
              deficiency: $MobileInspectionDeficienciesListFeedInput
            ) {
              assetInsepctionComponentFailureId
              deficiencyUUID
              status
            }
          }
        `);
  const { role, ...data } = document;
  const variables = {
    role: role ? role : getRoleForMutation(data),
    MobileInspectionDeficienciesListFeedInput: data,
  };

  return {
    query,
    variables,
  };
};

export const deficiencyListPushModifier = (doc: DeficiencyListDocument) => {
  const obj: AdditionalFields & { assetCategoryComponentId?: number | null } = {
    ...doc,
    assetCategoryComponentId:
      doc.discipline === Discipline.Shaft ? null : doc.assetCategoryComponentId,
  };
  const blackListedProp = [
    '_attachments',
    '_rev',
    '_deleted',
    'dateCreated',
    'dateModified',
    '_meta',
    'isDeleted',
    'role',
  ];
  blackListedProp.forEach(property => {
    obj[property as keyof AdditionalFields] = undefined;
  });
  return obj;
};
